import { NgFor, NgIf } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ApplyStyles } from '@com-delta-idp/mnx-skymiles-shared';
import {
  ChangeStylesDirective,
  DetailsEntryComponent,
  DividerComponent,
  GalleryComponent,
  ToggleAreaComponent
} from '@com-delta-omnichannel/aura';
import { EducationalContent } from './models/educational-content-page.interfaces';

@Component({
  selector: 'idp-educational-content-page',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    GalleryComponent,
    ToggleAreaComponent,
    DetailsEntryComponent,
    DividerComponent,
    ChangeStylesDirective
  ],
  templateUrl: './educational-content-page.component.html',
  styleUrls: ['./educational-content-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EducationalContentPageComponent {
  @Input() content: EducationalContent = {} as EducationalContent;

  getStyles(icon: string): ApplyStyles[] {
    return [
      {
        targetClass: ['aura-toggle-area__wrapper'],
        rules: { 'padding-right': window.innerWidth < 768 ? '15px' : '30px' }
      },
      {
        targetClass: ['aura-entry-item__contents__description__title'],
        rules: { 'font-size': '18px', 'font-family': 'Whitney-Medium' }
      },
      this.getEntryItemStyles(icon)
    ];
  }

  getEntryItemStyles = (icon: string): ApplyStyles => {
    return {
      targetClass: ['aura-entry-item'],
      rules: icon
        ? { 'padding-left': window.innerWidth < 768 ? '15px' : '30px' }
        : {
            padding: window.innerWidth < 768 ? '24px 15px' : '24px 30px'
          }
    };
  };
}
